export enum UserStatusEnum {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
  PENDING = 'pending',
  ARCHIVED = 'archived',
}

export enum UserRole {
  GUEST = 'guest',
  USER = 'user', // Guest which set up password becomes user
  EDITOR = 'editor',
  MITARBEITER = 'mitarbeiter',
  ADMIN = 'admin',
  ROOT = 'root',
}

export enum UserRoleDisplay {
  guest = 'Guest',
  user = 'User',
  editor = 'Editor',
  mitarbeiter = 'Mitarbeiter',
  admin = 'Admin',
  root = 'Root',
}

export enum UserStatusDisplay {
  'active' = 'Active',
  'deactivated' = 'Deactivated',
  'pending' = 'Pending',
  'archived' = 'Archived',
}

export const ROLE_LIST = [
  UserRole.GUEST,
  UserRole.USER,
  UserRole.EDITOR,
  UserRole.MITARBEITER,
  UserRole.ADMIN,
  UserRole.ROOT,
];

export function isRoleEnough(
  currentRole: UserRole | string | undefined,
  requiredRole: UserRole | string,
): boolean {
  if (currentRole === requiredRole) {
    return true;
  }

  return (
    ROLE_LIST.indexOf(currentRole as UserRole)
    >= ROLE_LIST.indexOf(requiredRole as UserRole)
  );
}
